import React, { Component } from "react"
import * as userHelpers from "../../helpers/userHelpers"
import Select from "../../elements/Select"
import * as sessionHelpers from "../../helpers/sessionHelpers"
import { Segment, Grid, Dropdown, Image } from "semantic-ui-react"
import { connect } from "react-redux"
import { CURRENT_ACCOUNT_ID, CURRENT_FLEET_ID } from "../../constants/application"
import CompanyDropdownLogo from "../../assets/images/company-dropdown-arrow.svg"
import { withTranslation } from "react-i18next"

class ManageAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: parseInt(sessionHelpers.getApplicationCookie(CURRENT_ACCOUNT_ID)),
      current_fleet: parseInt(sessionHelpers.getApplicationCookie(CURRENT_FLEET_ID)),
      Value_for_account_title: "",
      Value_for_fleet_title: ""
    }
  }

  handleChange = (value, accounts) => {
    this.setState({
      value: value,
      Value_for_account_title: accounts.find((o) => o.id === value).name
    })
    this.props.handleUserAccount(value)
    this.props.dispatch({
      type: "ACCOUNT_FLEETS",
      payload: { accountId: value },
      callback: this.afterAccountChangeRequest.bind(this)
    })
  }

  handleFleetChange(fleet_id) {
    sessionStorage.removeItem("current_fleet")
    this.setState({ current_fleet: fleet_id })
    this.props.dispatch({
      type: "FLEET_IMPERSONATION_SAGA",
      payload: { fleetId: fleet_id },
      callback: this.afterImpersonationRequest.bind(this)
    })
  }

  afterImpersonationRequest(status, data) {
    sessionHelpers.setApplicationCookie(CURRENT_ACCOUNT_ID, this.state.value)
    sessionHelpers.setApplicationCookie(CURRENT_FLEET_ID, this.state.current_fleet)
    window.location.reload()
  }

  afterAccountChangeRequest(status, data) {
    const { account_fleets } = this.props
    if (account_fleets.length == 1) {
      this.handleFleetChange(account_fleets[0].id)
    }
  }

  render() {
    const { currentUser, fleet, account_fleets, t } = this.props

    var accountFleets
    if (
      fleet.account &&
      account_fleets.length == 0 &&
      this.state.current_fleet == fleet.id &&
      this.state.value == fleet.account.id
    ) {
      accountFleets = currentUser.user_account_fleets
    } else {
      accountFleets = account_fleets
    }

    return (
      <div className="manage__account">
        {currentUser.user_accounts && currentUser.user_accounts.length > 0 ? (
          <div className="segment__custom-class">
            <Grid columns="equal" stackable>
              <Grid.Column>
                <Dropdown
                  search
                  className="fleetcore__select"
                  placeholder={t("account")}
                  inline
                  icon={<Image className="dropdown__logo" src={CompanyDropdownLogo} />}
                  options={
                    currentUser.user_accounts &&
                    userHelpers.selectAccountOptions(
                      currentUser.user_accounts.filter(
                        (a) => a.is_active === true && a.enrolled === true
                      ),
                      {
                        displayOtherID: true,
                        value: this.state.value
                      }
                    )
                  }
                  onChange={(event, { value }) =>
                    value && this.handleChange(value, currentUser.user_accounts)
                  }
                  value={this.state.value}
                  valueForTitle={
                    this.state.Value_for_account_title === ""
                      ? fleet.account.name
                      : this.state.Value_for_account_title
                  }
                />
              </Grid.Column>
            </Grid>
          </div>
        ) : (
          ""
        )}
      </div>
    )
  }
} // class HeaderLink

export default connect()(withTranslation("common")(ManageAccount))
